import styled from 'styled-components'

// components
import DefaultContainer from '../../components/DefaultContainer/DefaultContainer'

// styles
import { BREAKPOINTS } from '../../styles/constants'

export const PageContainer = styled(DefaultContainer)`
	position: relative;
`

export const MainContent = styled.div`
	margin-top: 20px;

	@media (min-width: ${BREAKPOINTS.sm}) {
		margin-top: 40px;
	}
`
